var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74155 2.78773L6.1239 5.13245C12.5055 6.49494 17.505 11.4945 18.8675 17.8761L21.2123 17.2585C21.7763 17.1099 22.1221 16.5381 21.9599 15.9778C21.0275 12.7575 19.3036 9.73613 16.7837 7.21626C14.2638 4.69641 11.2425 2.97247 8.02221 2.04011C7.46198 1.87791 6.89012 2.22373 6.74155 2.78773Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28766 12.1033L5.71225 6.69521C11.5325 7.90727 16.0927 12.4675 17.3047 18.2878L15.1302 18.8606C15.0266 18.2881 14.7535 17.7401 14.3109 17.2975C13.1553 16.1419 11.2818 16.1419 10.1262 17.2975C9.29694 18.1268 9.06276 19.3257 9.42364 20.3638L3.35121 21.9634C2.55412 22.1734 1.82663 21.4459 2.0366 20.6488L2.61377 18.4577C3.9773 19.4077 5.86648 19.2746 7.0827 18.0584C8.44839 16.6927 8.44839 14.4784 7.0827 13.1127C6.3178 12.3478 5.28674 12.0114 4.28766 12.1033ZM12.2502 11.9819C12.2502 11.0905 11.5276 10.3679 10.6362 10.3679C9.74477 10.3679 9.02215 11.0905 9.02215 11.9819C9.02215 12.8733 9.74477 13.596 10.6362 13.596C11.5276 13.596 12.2502 12.8733 12.2502 11.9819Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08075 16.6849L3.82089 13.8752C4.51669 13.5543 5.36796 13.6806 5.9414 14.254C6.67677 14.9894 6.67677 16.1817 5.9414 16.9171C5.20603 17.6524 4.01376 17.6524 3.27839 16.9171C3.20523 16.8439 3.13935 16.7662 3.08075 16.6849Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5587 19.2746L10.9952 19.9498C10.7681 19.4535 10.8589 18.8474 11.2675 18.4388C11.7927 17.9136 12.6444 17.9136 13.1696 18.4388C13.4029 18.6721 13.5326 18.9697 13.5587 19.2746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.6fa32ec4ee6171e94702759510aa146d.svg";
export { ForwardRef as ReactComponent };